import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface StatusTabsProps {
	status: number
	onChange: (status: number) => void
}

const tabs = [
	{ value: 1, label: '出售中' },
	{ value: 2, label: '仓库中' },
	{ value: 4, label: '售罄' },
	{ value: 5, label: '库存预警' },
	{ value: 6, label: '回收站' },
]

export function StatusTabs({ status, onChange }: StatusTabsProps) {
	return (
		<Tabs value={String(status)} onValueChange={(v) => onChange(Number(v))}>
			<TabsList>
				{tabs.map((tab) => (
					<TabsTrigger key={tab.value} value={String(tab.value)}>
						{tab.label}
					</TabsTrigger>
				))}
			</TabsList>
		</Tabs>
	)
}
